<form #form="ngForm">
	<h2 *ngIf="!this.payCategoryNote.isEdit" id="NOTE_ADD_TITLE" mat-dialog-title>
		Create New Note Field
	</h2>
	<h2 *ngIf="this.payCategoryNote.isEdit" id="NOTE_EDIT_TITLE" mat-dialog-title>
		Edit Note
	</h2>
	<mat-checkbox id="NOTE_IS_REQUIRED" name="noteexport" [(ngModel)]="payCategoryNote.isRequired"
		>Notes are Required
	</mat-checkbox>
	<mat-dialog-content>
		<div fxLayout="row" fxLayoutWrap="wrap">
			<div fxFlex.gt-sm="100%" fxFlex="100">
				<div layout-gt-xs="row" class="mb-2">
					<mat-form-field class="input-full-width">
						<input
							id="NOTE_NAME"
							name="name"
							matInput
							required
							placeholder="Name"
							[(ngModel)]="payCategoryNote.name"
						/>
					</mat-form-field>
					<span *ngIf="duplicateNoteNameError" class="mat-text-warn">{{ duplicateNoteNameError }}</span>
				</div>
				<div fxLayout="row" class="mb-2">
					<mat-form-field class="input-full-width">
						<mat-select
							id="NOTE_FIELD_TYPE"
							name="fieldType"
							required
							placeholder="Field Text"
							(selectionChange)="onFieldTypeChange()"
							[(ngModel)]="payCategoryNote.fieldType"
						>
							<mat-option *ngFor="let item of ['PickList', 'AutoComplete', 'FreeText']" [value]="item">
								{{ item }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<p class="font-weight-bold" *ngIf="this.payCategoryNote.fieldType === 'PickList'">Picklist Items</p>
				<div fxLayout="row" class="mb-2" *ngIf="this.payCategoryNote.fieldType === 'PickList'">
					<mat-list id="NOTE_PICK_LIST" *ngIf="this.payCategoryNote.pickListItems">
						<mat-list-item *ngFor="let item of this.payCategoryNote.pickListItems; let i = index">
							<div mat-line>{{ item }}</div>
							<button
								[id]="'NOTE_PICK_LIST_ITEM_' + i + '_CANCEL'"
								type="button"
								mat-icon-button
								(click)="clearNote(i)"
							>
								<mat-icon>cancel</mat-icon>
							</button>
						</mat-list-item>
					</mat-list>
				</div>
				<div fxLayout="row" *ngIf="this.payCategoryNote.fieldType === 'PickList'">
					<mat-form-field fxFlex>
						<input
							id="NOTE_PICK_LIST_ITEM_NAME"
							name="pickListItem"
							matInput
							[(ngModel)]="pickListItem"
							placeholder="Add Item"
						/>
					</mat-form-field>
					<button id="NOTE_PICK_LIST_ITEM_ADD" type="button" mat-mini-fab (click)="addNote()" color="blue">
						<mat-icon>add</mat-icon>
					</button>
				</div>
			</div>
		</div>
	</mat-dialog-content>

	<mat-dialog-actions fxLayoutAlign="end end">
		<button
			*ngIf="
				payCategoryNote &&
				this.payCategoryNote.name &&
				!payCategoryId &&
				!payCategoryNote.payCategoryNoteSettingId &&
				payCategoryNote.isRequired &&
				isValidPickList()
			"
			color="blue"
			id="NOTE_OK"
			mat-raised-button
			(click)="form.form.valid && addPayCategoryNote()"
		>
			Ok
		</button>
		<button
			*ngIf="
				payCategoryNote &&
				this.payCategoryNote.name &&
				payCategoryId &&
				!payCategoryNote.payCategoryNoteSettingId &&
				isValidPickList()
			"
			color="blue"
			id="NOTE_SAVE"
			mat-raised-button
			(click)="form.form.valid && addPayCategoryNote()"
		>
			Save
		</button>
		<button
			*ngIf="
				payCategoryNote &&
				this.payCategoryNote.name &&
				payCategoryId &&
				payCategoryNote.payCategoryNoteSettingId &&
				isValidPickList()
			"
			color="blue"
			id="NOTE_UPDATE"
			mat-raised-button
			(click)="updatePayCategoryNote()"
		>
			Update
		</button>
		<button type="button" id="NOTE_CLOSE" color="grey" mat-raised-button (click)="close()">
			Close
		</button>
	</mat-dialog-actions>
</form>
